import axios from "axios";

export default async function deleteForm(projectName, formName){
    await axios.delete(`/project/${projectName}/${formName}/delete`)
}